import type { SubtitlesSize, Subtitle, SubtitlesPositions } from '../../../components/subtitles/types';
import { useCoreSelector } from '../../CoreStore';

import type { SubtitlesGroup } from './types';

export const useSubtitlesSlice = {
  getGroup: (): SubtitlesGroup => {
    return useCoreSelector(({ subtitles }) => subtitles.group);
  },
  getIsEnabled: (): boolean => {
    return useCoreSelector(({ subtitles }) => subtitles.isEnabled);
  },
  getIsOnboarded: (): boolean => {
    return useCoreSelector(({ subtitles }) => subtitles.isOnboarded);
  },
  getPositions: (): SubtitlesPositions | null => {
    return useCoreSelector(({ config, subtitles }) => {
      const gameType = config.session?.gametype;
      return (gameType && subtitles.positionsRaw?.[gameType]) || null;
    });
  },
  getSize: (): SubtitlesSize => {
    return useCoreSelector(({ subtitles }) => subtitles.size);
  },
  getSubtitle: (): Subtitle => {
    return useCoreSelector(({ subtitles }) => subtitles.subtitle);
  },
};
